import ActivityLevelCard from "./ActivityLevelCard";
import {Info} from "lucide-react";
import type {ActivityLevelModel} from "../types/LiveEvent";

const Icon1 = (
    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.711426" y="0.0500488" width="30" height="30" rx="8.13" fill="#4E80EE"/>
        <g clipPath="url(#clip0_13909_11143)">
            <path d="M11.5447 18.3833H11.5488" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13.6282 18.3835V16.7168" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_13909_11143">
                <rect width="10" height="10" fill="white" transform="translate(10.7114 10.05)"/>
            </clipPath>
        </defs>
    </svg>
);

const Icon2 = (
    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.711426" y="0.0102539" width="30" height="30" rx="8.13" fill="#5EC269"/>
        <g clipPath="url(#clip0_13909_11167)">
            <path d="M11.5447 18.3435H11.5488" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13.6282 18.3437V16.677" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15.7114 18.3436V15.0103" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_13909_11167">
                <rect width="10" height="10" fill="white" transform="translate(10.7114 10.0103)"/>
            </clipPath>
        </defs>
    </svg>
);

const Icon3 = (
    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="1.28" width="30" height="30" rx="8.13" fill="#9D59EF"/>
        <g clipPath="url(#clip0_13602_6547)">
            <path d="M10.04 20.64H10.045" stroke="white" strokeWidth="1.83" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12.76 20.64V18.45" stroke="white" strokeWidth="1.83" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15.5 20.64V15.17" stroke="white" strokeWidth="1.83" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18.24 20.64V11.89" stroke="white" strokeWidth="1.83" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_13602_6547">
                <rect width="13.04" height="13.04" fill="white" transform="translate(9 9.78)"/>
            </clipPath>
        </defs>
    </svg>
);

const Icon4 = (
    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.63" width="30" height="30" rx="8.13" fill="#E87B35"/>
        <g clipPath="url(#clip0_13602_6559)">
            <path d="M10.04 19.99H10.045" stroke="white" strokeWidth="1.83" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12.76 19.99V17.8" stroke="white" strokeWidth="1.83" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15.5 19.99V14.52" stroke="white" strokeWidth="1.83" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18.24 19.99V11.24" stroke="white" strokeWidth="1.83" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20.98 9.07V19.99" stroke="white" strokeWidth="1.83" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_13602_6559">
                <rect width="13.04" height="13.04" fill="white" transform="translate(9 9.13)"/>
            </clipPath>
        </defs>
    </svg>
);

const Icon5 = (
    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.711426" y="0.950439" width="30" height="30" rx="8.13" fill="#DD524C"/>
        <g clipPath="url(#clip0_13909_11191)">
            <path d="M17.481 14.1841C17.9489 14.6528 18.2117 15.288 18.2117 15.9503C18.2117 16.6126 17.9489 17.2479 17.481 17.7166" stroke="white" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18.6594 13.0059C19.4398 13.7871 19.8781 14.8462 19.8781 15.9504C19.8781 17.0547 19.4398 18.1138 18.6594 18.895" stroke="white" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12.7636 18.895C11.9833 18.1138 11.5449 17.0547 11.5449 15.9504C11.5449 14.8462 11.9833 13.7871 12.7636 13.0059" stroke="white" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13.9419 17.7166C13.474 17.2479 13.2112 16.6126 13.2112 15.9503C13.2112 15.288 13.474 14.6528 13.9419 14.1841" stroke="white" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15.7115 16.7839C16.1717 16.7839 16.5448 16.4108 16.5448 15.9505C16.5448 15.4903 16.1717 15.1172 15.7115 15.1172C15.2513 15.1172 14.8782 15.4903 14.8782 15.9505C14.8782 16.4108 15.2513 16.7839 15.7115 16.7839Z" stroke="white" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_13909_11191">
                <rect width="10" height="10" fill="white" transform="translate(10.7114 10.9504)"/>
            </clipPath>
        </defs>
    </svg>
);

const getIcon = (attendees: number) => {
    if (attendees < 50) return Icon1;
    if (attendees <= 100) return Icon2;
    if (attendees <= 150) return Icon3;
    if (attendees <= 200) return Icon4;
    return Icon5;
};

interface ActivityLevelPanelProps {
    data: ActivityLevelModel[] | null;
}

const ActivityLevelPanel = ({data: activityLevels}: ActivityLevelPanelProps) => {
    return (
        <div
            className="w-3/12 h-full border border-gray-200 dark:border-gray-700 rounded-2xl text-[#364153] dark:text-gray-300 bg-white dark:bg-gray-800 flex flex-col">
            <div className="w-full flex items-center p-5 justify-between">
                <span className="text-lg text-gray-900 dark:text-gray-100">Activity Levels</span>
                <Info size={16} className="mr-1 text-gray-600 dark:text-gray-400"/>
            </div>
            <div className="flex-1 overflow-y-auto">
                <div
                    className="h-full overflow-auto bg-white dark:bg-gray-900 rounded-b-2xl [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
                    {Array.from(activityLevels || [], (item, i) => (
                        <ActivityLevelCard
                            title={item?.area_name || "Unknown Area"}
                            countEventActives={item?.total_events || 0}
                            countEventAttendees={item?.total_attendees || 0}
                            icon={getIcon(item?.total_attendees || 0)}
                            key={i}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default ActivityLevelPanel;